export default __webpack_public_path__ + "static/media/arrow-mobile.24d3e58a.svg";